import React, { useState } from "react";
import EditBannerIndex from "./EditBanner/index";
import useBanner from "../useBanner";
import EditImg from "../../../images/SideBar/Edit";
import Loader from "../../../components/Loader";
import CommonDataGrid from "../../../components/CommonDataGrid";
import Button from "../../../components/Botton";
import { Toaster } from "react-hot-toast";
import { GridColDef } from "@mui/x-data-grid";
import DeleteImg from "../../../images/SideBar/Delete";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";

const Banner: React.FC = () => {
  const {
    selectedBannerId,
    bannerData,
    loading,
    handleEdit,
    handleDelete,
    handleAdd,
  } = useBanner();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [standardToDelete, setStandardToDelete] = useState<string | null>(null);

  const openDeleteModal = (id: string) => {
    setStandardToDelete(id);
    setIsModalOpen(true);
  };

  const confirmDelete = () => {
    if (standardToDelete) {
      handleDelete(standardToDelete);
      setIsModalOpen(false);
    }
  };

  const closeDeleteModal = () => {
    setIsModalOpen(false);
    setStandardToDelete(null);
  };
  const columns: GridColDef[] = [
    {
      field: "image",
      headerName: "Banner Image",
      align: "center", // aligns the cell data
      headerAlign: "center", // aligns the header text
      flex: 0.6,
      renderCell: (params) => (
        <div className="flex justify-center">
          <img
            src={params.row.image}
            alt="Banner"
            className="w-[120px] h-[52px] object-fit"
          />
        </div>
      ),
    },
    {
      field: "Actions",
      headerName: "Actions",
      align: "center", // aligns the cell data
      headerAlign: "center", // aligns the header text
      flex: 0.4,
      renderCell: (params) => (
        <div className="flex h-full items-center justify-center">
          <button
            onClick={() => handleEdit(params.row._id)}
            className="text-fontColor hover:text-primary-2"
          >
            <EditImg />
          </button>
          <button
            onClick={() => openDeleteModal(params.row._id)}
            className="text-fontColor hover:text-red-500"
          >
            <DeleteImg />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="mx-auto p-4">
      {loading && <Loader />}
      {selectedBannerId ? (
        <EditBannerIndex bannerId={selectedBannerId} />
      ) : (
        <div className=" space-y-4 mt-4 bg-white p-4 rounded-b-lg  shadow-md ">
          <div className="grid justify-items-end  mr-1">
            <Button
              onClick={handleAdd}
              className="  py-1.5 px-9 rounded  "
              children="Add Banner"
              type="button"
            />
          </div>
          <CommonDataGrid
            id="banner"
            rows={bannerData}
            columns={columns}
            loading={!bannerData}
            showConfirmation={false}
            confirmationMessage={""}
            onCancelDelete={function (): void {
              throw new Error("Function not implemented.");
            }}
            onConfirmDelete={function (): void {
              throw new Error("Function not implemented.");
            }}
            toolbarProps={{ toolbar: { showQuickFilter: true } }}
          />
        </div>
      )}
      <ConfirmationModal
        isOpen={isModalOpen}
        onClose={closeDeleteModal}
        onConfirm={confirmDelete}
        message="Are you sure you want to delete this Banner Image?"
      />
      <Toaster />
    </div>
  );
};

export default Banner;
